import type { ProjectType } from "@reno-estimator/core";
import { useEstimatorFlow, STEP_TITLES } from "./state/useEstimatorFlow.js";
import { ProgressBar } from "./components/ui/ProgressBar.js";
import { Step1ProjectType } from "./components/steps/Step1ProjectType.js";
import { Step2RoomSize } from "./components/steps/Step2RoomSize.js";
import { Step3WhatChanging } from "./components/steps/Step3WhatChanging.js";
import { Step4FinishLevel } from "./components/steps/Step4FinishLevel.js";
import { Step5Location } from "./components/steps/Step5Location.js";
import { Step6Timeline } from "./components/steps/Step6Timeline.js";
import { Step7Estimate } from "./components/steps/Step7Estimate.js";
import { ConsentBanner } from "./components/privacy/ConsentBanner.js";
import { PrivacyPolicyLink } from "./components/privacy/PrivacyPolicyLink.js";

export interface AppProps {
  /** See UseEstimatorFlowOptions.initialProjectType - passed straight through. Optional; omitted by the standalone app's own main.tsx. */
  initialProjectType?: ProjectType;
}

export default function App({ initialProjectType }: AppProps = {}) {
  const flow = useEstimatorFlow({ initialProjectType });

  return (
    <div className="app">
      <header className="app__header">
        <p className="app__brand">Renovation Cost Estimator</p>
        {flow.currentStepId !== "estimate" ? (
          <ProgressBar stepIndex={flow.stepIndex} totalSteps={flow.totalSteps - 1} stepLabel={STEP_TITLES[flow.currentStepId]} />
        ) : null}
      </header>

      <main className="app__main" id="main-content">
        {flow.currentStepId === "project-type" ? <Step1ProjectType flow={flow} /> : null}
        {flow.currentStepId === "room-size" ? <Step2RoomSize flow={flow} /> : null}
        {flow.currentStepId === "changes" ? <Step3WhatChanging flow={flow} /> : null}
        {flow.currentStepId === "finish" ? <Step4FinishLevel flow={flow} /> : null}
        {flow.currentStepId === "location" ? <Step5Location flow={flow} /> : null}
        {flow.currentStepId === "timeline" ? <Step6Timeline flow={flow} /> : null}
        {flow.currentStepId === "estimate" ? <Step7Estimate flow={flow} /> : null}
      </main>

      <footer className="app__footer">
        <PrivacyPolicyLink />
      </footer>

      <ConsentBanner />
    </div>
  );
}
